import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { snakes } from '@utils/lodash';
import { Numeric, WithParams } from '@utils/typescript';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';
import { Collaboration } from '@models/Collaboration';

export type GetAllCollaborationParams = PaginationParams & WithParams<{
  collaboratable_type: string;
  collaboratable_id: number;
}>;

export type CreateCollaborationParams = WithParams<{
  collaboratable_type: string;
  collaboratable_id: number;
  collaborator_id: number;
  brokerage_percentage: Numeric;
}>;

export type UpdateCollaborationParams = WithParams<{
  id: number;
  brokerage_percentage: Numeric;
}>;

export type DeleteCollaborationParams = WithParams<{
  id: number;
}>;

export class CollaborationApi {
  static getAll = async (params: GetAllCollaborationParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/collaborations`, { params: snakes(params) })
      .then((response) => paginate(response) as [Collaboration[], Pagination]);
  };

  static create = async (params: CreateCollaborationParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/user/collaborations`, snakes(params))
      .then((response) => humps(response.data) as Collaboration);
  };

  static update = async ({ id, ...rest }: UpdateCollaborationParams) => {
    return await authAxios
      .put(`${API_V1_BASE}/user/collaborations/${id}`, snakes(rest))
      .then((response) => humps(response.data) as Collaboration);
  };

  static delete = async ({ id }: DeleteCollaborationParams) => {
    return await authAxios.delete(`${API_V1_BASE}/user/collaborations/${id}`);
  };
}
